module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAARVBMVEUAAAAyMjIzMzMzMzMzMzMzMzMzMzMyMjIzMzMyMjIzMzMzMzMyMjIyMjI0NDQzMzMxMTE1NTUzMzMyMjIzMzMyMjIzMzN2Bh1xAAAAFnRSTlMAgFWq3fPrT0c2+eU7cUAyKBG/uIhmy7slBQAAAGxJREFUSMft1UkOgCAUBFFwQEFQcfj3P6rBE1ALEoz0+tW61QcXjjsS34vIBL0E6GWHvmPeTWX9SP1clzfUr8wv1PuyfrDF/An98Pot2/vkTfK5c6nQILiEFl0rWvGzwtJCK1KYdIpkUava9wDRIhF0OdYKVwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/resource/back.png
// module id = dG7S
// module chunks = 1